var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentLinedGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.25H14.25V15H16.5V17.25ZM20.25 15H18V17.25H20.25V15ZM16.5 18.75H14.25V21H16.5V18.75ZM20.25 18.75H18V21H20.25V18.75ZM13.5 4.5H7.5V6H13.5V4.5ZM11.25 19.5H3V16.5H4.5V15H3V11.25H4.5V9.75H3V6H4.5V4.5H3V1.5H16.5V12.75H18V1.5C18 0.675 17.325 0 16.5 0H3C2.175 0 1.5 0.675 1.5 1.5V4.5H0V6H1.5V9.75H0V11.25H1.5V15H0V16.5H1.5V19.5C1.5 20.325 2.175 21 3 21H11.25V19.5ZM13.5 9.75H7.5V11.25H13.5V9.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentLinedGrid);
export default __webpack_public_path__ + "static/media/ic-document-lined-grid.942b5781334db47d991adddcdfde2bac.svg";
export { ForwardRef as ReactComponent };